import { Link } from "wouter";

const LOGO = "/manus-storage/cyprus-prive-relief-256_ff9206d9.webp";
const LOGO_RETINA = "/manus-storage/cyprus-prive-relief-512_904914b3.webp";

/** Native-alpha gold relief: no tile, backplate or rectangular shadow. */
export function HeaderBrand({ label }: { label: string }) {
  return <Link href="/" className="header-brand" aria-label={label}>
    <img
      className="header-brand__relief"
      src={LOGO}
      srcSet={`${LOGO} 256w, ${LOGO_RETINA} 512w`}
      sizes="(min-width: 1024px) 136px, 112px"
      width={256}
      height={192}
      alt="CYPRUS PRIVÉ"
      decoding="async"
      fetchPriority="high"
      draggable={false}
    />
  </Link>;
}
